import { render, staticRenderFns } from "./HacizTalepEvrakAdiRadio.vue?vue&type=template&id=20e79652"
import script from "./HacizTalepEvrakAdiRadio.vue?vue&type=script&lang=ts"
export * from "./HacizTalepEvrakAdiRadio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports